import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'
import { Row, Col, Form, Button } from 'antd'
import { Link } from 'react-router-dom'
import { FORM } from '../../../utils/enums'
import InputField from '../../../atoms/InputField'
import InputPasswordField from '../../../atoms/InputPasswordField'
import Planshelf from '../../../assets/images/image-planshelf.svg?react'
// eslint-disable-next-line import/no-cycle
import validateLoginForm from './validateLoginForm'

export interface ILoginForm {
	email: string
	password: string
}

type ComponentProps = {}

type Props = InjectedFormProps<ILoginForm, ComponentProps> & ComponentProps

const LoginForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit, submitting } = props

	return (
		<Form layout={'vertical'} className={'mt-20'} onSubmitCapture={handleSubmit}>
			<Row gutter={[16, 16]} justify={'center'}>
				<Col span={14}>
					<Planshelf className={'mb-10'} />
				</Col>
				<Col span={14}>
					<h3 className={'heading-3'}>{t('loc:Login')}</h3>
				</Col>
				<Col span={14}>
					<Field component={InputField} label={t('loc:Email')} placeholder={t('loc:Enter email')} name={'email'} size={'large'} required />
				</Col>
			</Row>
			<Row gutter={[16, 16]} justify={'center'}>
				<Col span={14}>
					<Field
						component={InputPasswordField}
						label={t('loc:Password')}
						placeholder={t('loc:Enter password')}
						type={'password'}
						size={'large'}
						name={'password'}
						required
					/>
				</Col>
				<Col span={14}>
					<Button type={'primary'} block className={'extd-btn'} size={'large'} htmlType={'submit'} disabled={submitting} loading={submitting}>
						{t('loc:Log in')}
					</Button>
				</Col>
				<Col span={14}>
					<Link to={t('paths:forgot-password') as string} className={'pt-2'}>
						<span className={'text-m-regular text-blue-600'}>{t('loc:Forgot password?')}</span>
					</Link>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<ILoginForm, ComponentProps>({
	form: FORM.LOGIN,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	validate: validateLoginForm
})(LoginForm)

export default form
